import { playgroundApi } from '../../common/api-client';
import {
  BaseMonthlyPolicyRow, BasePolicyRow, Coverages, PremiumBreakdown, SimulationWarning,
} from '../_shared';
import { APVSelectFormValues } from './schema';

export const PRODUCT = 'APV_SELECT';

export interface APVSelectPolicyRow extends BasePolicyRow {
  fiscal_contributions?: number;
}

export interface APVSelectMonthlyRow extends BaseMonthlyPolicyRow {
  fiscal_contributions?: number;
}

export interface APVSelectResponse {
  coverages: Coverages;
  currency: string;
  uf_value: number;
  premium: PremiumBreakdown;
  monthly_pension_with_afp: number;
  monthly_pension_afp_with_apv_transfer: number;
  monthly_pension_afp_apv_transfer_and_bice: number;
  total_monthly_projected_pension: number;
  total_afp_savings: number;
  total_apv_savings: number;
  total_savings: number;
  projection_by_year: APVSelectPolicyRow[];
  projection_by_month?: APVSelectMonthlyRow[];
  warnings?: SimulationWarning[];
}

export interface SimulateParams {
  values: APVSelectFormValues;
}

export async function simulateAPVSelect({
  values,
}: SimulateParams): Promise<APVSelectResponse> {
  const payload = {
    product: PRODUCT, ...values, origin_process_id: 1, debug: true,
  };
  const { data } = await playgroundApi.post<APVSelectResponse>(
    'projection/',
    payload,
  );
  return data;
}
